import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IFloatingFilterAngularComp } from 'ag-grid-angular';
import { IFloatingFilterParams } from 'ag-grid-community';

@Component({
  selector: 'app-datetime-floating-filter',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="datetime-floating-filter d-flex align-items-center w-100 h-100">
      <input type="text" class="form-control form-control-sm" [value]="displayValue" readonly
        placeholder="No filter" style="font-size: 11px; cursor: pointer;" (click)="openParentFilter()">
    </div>
  `,
  styles: [`
    .datetime-floating-filter input {
      background-color: #fff;
    }
    .datetime-floating-filter input:not(:placeholder-shown) {
      background-color: #FFF9C4;
    }
  `],
})
export class DatetimeFloatingFilterComponent implements IFloatingFilterAngularComp {
  private params!: IFloatingFilterParams;
  displayValue = '';

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
  }

  onParentModelChanged(parentModel: any): void {
    if (!parentModel) {
      this.displayValue = '';
      return;
    }

    const type = parentModel.type;
    const dateValue = parentModel.filter || parentModel.dateFrom;
    const from = this.formatShort(dateValue);
    const to = this.formatShort(parentModel.dateTo);

    switch (type) {
      case 'equals':
        this.displayValue = from;
        break;
      case 'greaterThan':
        this.displayValue = `After ${from}`;
        break;
      case 'lessThan':
        this.displayValue = `Before ${from}`;
        break;
      case 'inRange':
        this.displayValue = to ? `${from} — ${to}` : `From ${from}`;
        break;
      default:
        this.displayValue = from;
    }
  }

  openParentFilter(): void {
    this.params.showParentFilter();
  }

  private formatShort(dateStr: string | null): string {
    if (!dateStr) return '';
    const d = new Date(dateStr.replace(' ', 'T'));
    const pad = (n: number) => n.toString().padStart(2, '0');
    const month = d.toLocaleString(undefined, { month: 'short' });
    const hasTime = d.getHours() !== 0 || d.getMinutes() !== 0;
    const base = `${pad(d.getDate())} ${month} ${d.getFullYear()}`;
    return hasTime ? `${base} ${pad(d.getHours())}:${pad(d.getMinutes())}` : base;
  }
}
